export var IncomeOrExpenseType;
(function (IncomeOrExpenseType) {
    IncomeOrExpenseType["Income"] = "income";
    IncomeOrExpenseType["Expense"] = "expense";
})(IncomeOrExpenseType || (IncomeOrExpenseType = {}));
export var IncomeOrExpenseApportionmentMode;
(function (IncomeOrExpenseApportionmentMode) {
    IncomeOrExpenseApportionmentMode["Single"] = "single";
    IncomeOrExpenseApportionmentMode["Multiple"] = "multiple";
})(IncomeOrExpenseApportionmentMode || (IncomeOrExpenseApportionmentMode = {}));
export var IncomeType;
(function (IncomeType) {
    IncomeType["DepositInterestIncome"] = "depositInterestIncome";
    IncomeType["DividendIncome"] = "dividendIncome";
    IncomeType["InterestIncome"] = "interestIncome";
    IncomeType["InterestOutsideOfCarryIncome"] = "interestOutsideOfCarryIncome";
    IncomeType["OtherIncome"] = "otherIncome";
    IncomeType["OtherOutsideOfCarryIncome"] = "otherOutsideOfCarryIncome";
    IncomeType["AccruedIncome"] = "accruedIncome";
})(IncomeType || (IncomeType = {}));
export var ExpenseType;
(function (ExpenseType) {
    ExpenseType["AccountingFeeExpense"] = "accountingFeeExpense";
    ExpenseType["AdministrationFeeExpense"] = "administrationFeeExpense";
    ExpenseType["AdvisoryFeeExpense"] = "advisoryFeeExpense";
    ExpenseType["AifmFeeExpense"] = "aifmFeeExpense";
    ExpenseType["AuditFeeExpense"] = "auditFeeExpense";
    ExpenseType["BankCharges"] = "bankCharges";
    ExpenseType["ConsultancyFeeExpense"] = "consultancyFeeExpense";
    ExpenseType["CustodianFeeExpense"] = "custodianFeeExpense";
    ExpenseType["DepositoryFeeExpense"] = "depositoryFeeExpense";
    ExpenseType["DirectorsFeeExpense"] = "directorsFeeExpense";
    ExpenseType["IncentiveFeeExpense"] = "incentiveFeeExpense";
    ExpenseType["InformationTechnologyExpense"] = "informationTechnologyExpense";
    ExpenseType["InsuranceExpense"] = "insuranceExpense";
    ExpenseType["OtherExpense"] = "otherExpense";
    ExpenseType["LegalAndProfessionalFeesExpense"] = "legalAndProfessionalFeesExpense";
    ExpenseType["ManagementFee"] = "managementFee";
    ExpenseType["OperatingExpense"] = "operatingExpense";
    ExpenseType["OperationAndMaintenanceExpense"] = "operationAndMaintenanceExpense";
    ExpenseType["OrganisationExpense"] = "organisationExpense";
    ExpenseType["PlacementFeeExpense"] = "placementFeeExpense";
    ExpenseType["RegulatoryAndTaxFee"] = "regulatoryAndTaxFee";
    ExpenseType["ReimbursementFeeExpense"] = "reimbursementFeeExpense";
    ExpenseType["SecretarialFeeExpense"] = "secretarialFeeExpense";
    ExpenseType["SundryExpense"] = "sundryExpense";
    ExpenseType["TaxationExpense"] = "taxationExpense";
    ExpenseType["TravelAndEntertainmentExpense"] = "travelAndEntertainmentExpense";
    ExpenseType["InterestExpense"] = "interestExpense";
    ExpenseType["AccruedExpense"] = "accruedExpense";
})(ExpenseType || (ExpenseType = {}));
export var IncomeExpenseCategoryType;
(function (IncomeExpenseCategoryType) {
    // Income types
    IncomeExpenseCategoryType["DepositInterestIncome"] = "depositInterestIncome";
    IncomeExpenseCategoryType["DividendIncome"] = "dividendIncome";
    IncomeExpenseCategoryType["InterestIncome"] = "interestIncome";
    IncomeExpenseCategoryType["InterestOutsideOfCarryIncome"] = "interestOutsideOfCarryIncome";
    IncomeExpenseCategoryType["OtherIncome"] = "otherIncome";
    IncomeExpenseCategoryType["OtherOutsideOfCarryIncome"] = "otherOutsideOfCarryIncome";
    IncomeExpenseCategoryType["AccruedIncome"] = "accruedIncome";
    // Expense types
    IncomeExpenseCategoryType["AccountingFeeExpense"] = "accountingFeeExpense";
    IncomeExpenseCategoryType["AdministrationFeeExpense"] = "administrationFeeExpense";
    IncomeExpenseCategoryType["AdvisoryFeeExpense"] = "advisoryFeeExpense";
    IncomeExpenseCategoryType["AifmFeeExpense"] = "aifmFeeExpense";
    IncomeExpenseCategoryType["AuditFeeExpense"] = "auditFeeExpense";
    IncomeExpenseCategoryType["BankCharges"] = "bankCharges";
    IncomeExpenseCategoryType["ConsultancyFeeExpense"] = "consultancyFeeExpense";
    IncomeExpenseCategoryType["CustodianFeeExpense"] = "custodianFeeExpense";
    IncomeExpenseCategoryType["DepositoryFeeExpense"] = "depositoryFeeExpense";
    IncomeExpenseCategoryType["DirectorsFeeExpense"] = "directorsFeeExpense";
    IncomeExpenseCategoryType["IncentiveFeeExpense"] = "incentiveFeeExpense";
    IncomeExpenseCategoryType["InformationTechnologyExpense"] = "informationTechnologyExpense";
    IncomeExpenseCategoryType["InsuranceExpense"] = "insuranceExpense";
    IncomeExpenseCategoryType["OtherExpense"] = "otherExpense";
    IncomeExpenseCategoryType["LegalAndProfessionalFeesExpense"] = "legalAndProfessionalFeesExpense";
    IncomeExpenseCategoryType["ManagementFee"] = "managementFee";
    IncomeExpenseCategoryType["OperatingExpense"] = "operatingExpense";
    IncomeExpenseCategoryType["OperationAndMaintenanceExpense"] = "operationAndMaintenanceExpense";
    IncomeExpenseCategoryType["OrganisationExpense"] = "organisationExpense";
    IncomeExpenseCategoryType["PlacementFeeExpense"] = "placementFeeExpense";
    IncomeExpenseCategoryType["RegulatoryAndTaxFee"] = "regulatoryAndTaxFee";
    IncomeExpenseCategoryType["ReimbursementFeeExpense"] = "reimbursementFeeExpense";
    IncomeExpenseCategoryType["SecretarialFeeExpense"] = "secretarialFeeExpense";
    IncomeExpenseCategoryType["SundryExpense"] = "sundryExpense";
    IncomeExpenseCategoryType["TaxationExpense"] = "taxationExpense";
    IncomeExpenseCategoryType["TravelAndEntertainmentExpense"] = "travelAndEntertainmentExpense";
    IncomeExpenseCategoryType["InterestExpense"] = "interestExpense";
    IncomeExpenseCategoryType["AccruedExpense"] = "accruedExpense";
    // Gain/Loss types
    IncomeExpenseCategoryType["RealisedGainOnInvestments"] = "realisedGainOnInvestments";
    IncomeExpenseCategoryType["UnrealisedGainOnInvestments"] = "unrealisedGainOnInvestments";
    IncomeExpenseCategoryType["RealisedFXGainOnInvestments"] = "realisedFXGainOnInvestments";
    IncomeExpenseCategoryType["UnrealisedFXGainOnInvestments"] = "unrealisedFXGainOnInvestments";
    IncomeExpenseCategoryType["OtherRealisedFXGain"] = "otherRealisedFXGain";
    IncomeExpenseCategoryType["OtherUnrealisedFXGain"] = "otherUnrealisedFXGain";
})(IncomeExpenseCategoryType || (IncomeExpenseCategoryType = {}));
export var IncomeOrExpenseState;
(function (IncomeOrExpenseState) {
    IncomeOrExpenseState["Payable"] = "payable";
    IncomeOrExpenseState["Receivable"] = "receivable";
    IncomeOrExpenseState["Accrued"] = "accrued";
})(IncomeOrExpenseState || (IncomeOrExpenseState = {}));
export var CustomIncomeOrExpenseType;
(function (CustomIncomeOrExpenseType) {
    CustomIncomeOrExpenseType["CustomActionType"] = "customActionType";
})(CustomIncomeOrExpenseType || (CustomIncomeOrExpenseType = {}));
export var IncomeOrExpenseTransactionSubType;
(function (IncomeOrExpenseTransactionSubType) {
    IncomeOrExpenseTransactionSubType["AccruedIncomeDebit"] = "accruedIncomeDebit";
    IncomeOrExpenseTransactionSubType["AccruedIncomeCredit"] = "accruedIncomeCredit";
    IncomeOrExpenseTransactionSubType["AccruedExpenseDebit"] = "accruedExpenseDebit";
    IncomeOrExpenseTransactionSubType["AccruedExpenseCredit"] = "accruedExpenseCredit";
})(IncomeOrExpenseTransactionSubType || (IncomeOrExpenseTransactionSubType = {}));
//# sourceMappingURL=index.js.map